export enum AppEntities {
  Vessel = 'Vessel',
  Transport = 'Transport',
  Vehicle = 'Vehicle',
}
